import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Yii } from 'libraries/interfaces/Yii';
import { IconDefinition, faMoneyBill, faPercent } from '@fortawesome/free-solid-svg-icons';
import { EAirSearchFields } from 'app_locobook/air-search/e-air-search-fields';

export interface IAirSearchPrice {
  plusOrMinus: {
    percentage: number;
  };
  value: number;
  fareType?: string[];
}

class Wording {
  public readonly valueLabel: string = Yii.t('wui-shared-js', 'Prix par adulte (EUR)');
  public readonly percentageLabel: string = Yii.t('wui-shared-js', 'Tolérance');
}

@Component({
  selector: 'air-search-price-form',
  templateUrl: './air-search-price-form.component.html',
  styleUrls: ['./air-search-price-form.component.scss']
})
export class AirSearchPriceFormComponent implements OnInit {
  public airSearchPriceForm: FormGroup;
  public wording: Wording = new Wording();
  public iconMoney: IconDefinition = faMoneyBill;
  public iconPercent: IconDefinition = faPercent;
  public eAirSearchFields: typeof EAirSearchFields = EAirSearchFields;
  public airSearchForm: FormGroup;

  constructor(
      private readonly formGroupDirective: FormGroupDirective,
      private readonly fb: FormBuilder,
  ) { }

    public ngOnInit(): void {
      this.initAirSearchPriceForm();
      this.initAirSearchForm();
    }

    private initAirSearchPriceForm(): void {
        this.airSearchPriceForm = this.fb.group({
          plusOrMinus: this.fb.group({
            percentage: [0, [Validators.min(0)]]
          }),
          value: [0, [Validators.min(0)]]
        });
    }

    private initAirSearchForm(): void {
      this.airSearchForm = this.formGroupDirective.form;
      if (this.airSearchForm.contains(EAirSearchFields.price)) {
        const plusOrMinusForm = this.fb.group({
          percentage: [0, [Validators.min(0)]]
        });
        const valueForm = new FormControl(0, [Validators.min(0)]);
        (this.airSearchForm.get(EAirSearchFields.price) as FormGroup).addControl(EAirSearchFields.plusOrMinus, plusOrMinusForm);
        (this.airSearchForm.get(EAirSearchFields.price) as FormGroup).addControl(EAirSearchFields.value, valueForm);
      } else {
        this.airSearchForm.addControl(EAirSearchFields.price, this.airSearchPriceForm);
      }
    }
}
